import { Field } from 'react-final-form'

import Checkbox from 'common/components/checkbox'
import FormItem from 'common/components/formItem'
import { getFieldError } from 'features/projects/helpers'

interface Props {
  isCreating: boolean
}
const SandboxCard = ({ isCreating }: Props) => {
  return (
    <>
      <div className="">
        <Field<boolean>
          name="sandboxModeEnabled"
          initialValue={isCreating ? false : undefined}
        >
          {({ input, meta }) => (
            <FormItem error={getFieldError(meta)}>
              <Checkbox
                data-cy="sandbox-mode-checkbox"
                label="Sandbox mode"
                isChecked={input.value}
                onChange={input.onChange}
              />
            </FormItem>
          )}
        </Field>
      </div>
    </>
  )
}

export default SandboxCard
